import { Controller } from "@hotwired/stimulus"

// Enterprise signup page (`accounts/register`).
export default class extends Controller {
  static targets = ["form", "registrationBlock", "loading"]

  connect() {
    $("#user_full_name").focus()
    this.#stretchContainer()
  }

  submit(event) {
    event.preventDefault()

    $(this.formTarget).ajaxSubmit({
      target: "#wrap",
      dataType: "json",
      beforeSubmit: () => {
        $(this.registrationBlockTarget).find(".alert").remove()
        $(this.registrationBlockTarget).hide()
        $(this.loadingTarget).fadeIn(500)
      },
      success: (response) => {
        $(this.loadingTarget).hide()
        $(this.registrationBlockTarget).show()

        if (response.success && response.signed_in === false) {
          $(this.registrationBlockTarget).parent().html(response.message)
        } else if (response.success && response.signed_in) {
          window.location = "/apps"
        } else {
          this.#clearPasswordFields()
          this.#showError(response.message)
        }
      },
    })
  }

  #stretchContainer() {
    document.querySelectorAll(".qb-container").forEach((container) => {
      if (container.querySelector(".wrap-register")) {
        container.style.height = "100%"
      }
    })
  }

  #clearPasswordFields() {
    $("#user_password").val("")
    $("#user_password_confirmation").val("")
  }

  #showError(messages) {
    const title = $("<h4>").text("Errors:")
    const error = $("<div>").addClass("alert alert-danger").append(title)
    $.each(messages, function (_index, msg) {
      error.append($("<p>").text(msg))
    })
    $(this.registrationBlockTarget).prepend(error)
  }
}
